export default __webpack_public_path__ + "static/N0226-7875da7aa8203e6b54c163e8ba78e91a.png";